import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  .modal-title {
    color: ${({ theme: { token } }) => token.colorTextHeading};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
  }
`;
